export default {
  RESET(state) {
    state.trainings = []
  },
  SET_TRAININGS(state, trainings) {
    state.trainings = trainings
  }
}
